import React, { lazy, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import { addLinkSuccess, redirectTo } from '../../actions';
import { Link } from '../../api';

import { currentUserSelector } from '../../reducers/selectors';
import queryString from 'query-string';


import keys from 'lodash/keys';
import indexOf from 'lodash/indexOf';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import reject from 'lodash/reject';
import isNil from 'lodash/isNil';
import find from 'lodash/find';
import map from 'lodash/map';

// import SmartPageForm from './SmartPageForm';
const SmartPageForm  = lazy(() => import('./SmartPageForm'));


const mapStateToProps = state => ({currentUser: currentUserSelector(state), routerPath: ((state.router || {}).location || {}).pathname});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addLinkSuccess, redirectTo }, dispatch)
};

class NewSmartPage extends Component {
  
  
  constructor(props) {
    super(props);
    
    this.state = {
      initialValues: {}
    }
  }
  
  componentWillMount () {
    const { currentUser, routerPath, redirectTo } = this.props;
    const queryparams = queryString.parse((this.props.location || {}).search) || {};
    
    const {slug, ref, fte} = queryString.parse((this.props.location || {}).search) || {};
    const initialValues = this.prepareInitialValues(this.props.initialValues || {settings: {}});
    
    this.setState({
      initialValues: {slug, ref, ...initialValues, settings: (initialValues && initialValues.settings) || {type: 'smartpage' }},
      showFTE: !!fte
    });
    
    if (
      (currentUser || localStorage.getItem('smartpageFteDone') === '1' || localStorage.getItem('jwtToken'))
      && ((routerPath || '').replace(/\//gi, '') === 'bio' || indexOf(keys(queryparams), "lp") >= 0)
    ){
      redirectTo('/');
    }
  }
  
  onSuccess(res) {
    const { addLinkSuccess, onSuccess } = this.props; 
    addLinkSuccess(res);
    
    if (onSuccess && typeof onSuccess === 'function')
      onSuccess(res)
  }
  
  enrichSublinksList (sublinks, list, merge = {}, fn){
    return reject(map(list, (ln) => {
      let l = omit(ln, ['visible']); 
      
      if (ln.visible === false)
        l.hide = true
      
      if (!l.id)
        return {...merge, ...l}
      
      const sublink = find(sublinks, {id: l.id})
      if (!sublink)
        return null
      return {...merge, ...pick(sublink, ['url', 'can_change_url', 'meta']), ...l}
    }), isNil)
  }
  
  prepareInitialValues (link){
    const { sublinks, settings:{blocks, messengers, social_links, buttons} } = link
    const settings = {...link.settings, type: "smartpage", blocks:this.enrichSublinksList(sublinks, blocks || buttons, {layout: 'button'}), messengers:this.enrichSublinksList(sublinks, messengers), social_links:this.enrichSublinksList(sublinks, social_links)}
    
    return {...pick(link, ['id', 'domain_id', 'slug', 'title',  'description', 'pixel_set_ids', 'tags', 'meta', 'settings', 'gsm_partner_key', 'ref', 'special_k', 'special_h']), settings}
  }
  
  render() {
    const { initialValues, showFTE } = this.state;
    
    return (
      <SmartPageForm showFTE={showFTE} initialValues={initialValues} onSubmit={Link.create} onSuccess={this.onSuccess.bind(this)} resetOnSuccess={true} />
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(NewSmartPage);


// WEBPACK FOOTER //
// ./src/components/SmartPages/NewSmartPage.js